
import FiltersBlock from "@/components/FiltersBlock.vue";
import ExcursionsView from "@/components/ExcursionsView.vue";
import {Excursion} from "@/services/excursions/types";
import * as excursionsService from "@/services/excursions";
import * as filtersService from "@/services/filters"
import {defineComponent} from "vue"
import {IFilter} from "@/services/filters/types/IFilter";
import {ExcursionFilter} from "@/services/filters/types";
import NumberFilterLogic from "@/services/filters/types/NumberFilter";
import SelectFilterLogic from "@/services/filters/types/SelectFilter";
import {AxiosError} from "axios";
import ErrorView from "@/components/ErrorView.vue";
import LoadingDots from "@/components/LoadingDots.vue";
import {buildSmartFilter} from "@/services/filters";
import {SeoService} from "@/services/seo";

export default defineComponent({
  components: {
    LoadingDots,
    ErrorView,
    FiltersBlock,
    ExcursionsView,
  },
  name: "CatalogView",
  data: () => ({
    excursions: [] as Excursion[],
    filters: [] as IFilter[],
    error: null as AxiosError | null,
    isSearching: true,
    isFilterOpened: false,
  }),
  inject: ["sef_url"],
  methods: {
    showFilters() {
      if(this.isFilterOpened) {
        document.body.style.position = '';
        document.body.style.top = '';
      }else{
        document.body.style.position = 'fixed';
        document.body.style.top = `-${window.scrollY}px`;
      }
      this.isFilterOpened = !this.isFilterOpened
    },
    createFilter(filter: ExcursionFilter) {
      if (filter.type === "number") {
        return (new NumberFilterLogic(filter,{
          measure: filter.code === 'PRICE' ? 'руб.' : ''
        }));
      }

      if (filter.type === "select") {
        return (new SelectFilterLogic(filter));
      }

      throw new Error("Unknown filter type: " + filter.type);
    }
  },
  watch: {
    filters: {
      async handler(newValue: IFilter[]) {
        const changed = newValue.filter(filter=>filter.changed())
        const path = buildSmartFilter(changed.map(filter=>({
          name: filter.key,
          value:
              filter instanceof NumberFilterLogic ? filter.values : (filter instanceof SelectFilterLogic ?
                  filter.checked.map(option=>filter.values.find(value => value.name === option)!.code) : [])
        })))

        const seo = await SeoService.getSeo(`/excursions/${this.cityCode}/${path}`)
        const el = document.querySelector(".story .container_3 .news-detail .die_white") as HTMLElement
        if(!el) {
          return
        }
        if('TITLE' in seo) {
          el.innerHTML = seo.DESCRIPTION
          el.style.display = 'block'
        }else {
          el.style.display = 'none'
        }
      },
      deep: true
    }
  },
  computed: {
    filteredExcursions() {
      let excursions = this.excursions;

      for (let filter of this.filters) {
        let temp: Excursion[] = [];

        for (let excursion of excursions) {
          if (filter.test(excursion)) {
            temp.push(excursion);
          }
        }

        excursions = temp;
      }

      return excursions;
    },
    cityCode(): string {
      return this.$route.params.cityCode as string;
    }
  },
  async mounted() {
    if(!this.cityCode) {
      return
    }
    try {
      const response = await excursionsService.index(this.cityCode)
      this.excursions = response.DATA;
      this.isSearching = false;
    } catch (e) {
      this.error = e as AxiosError;
      return;
    }

    const filters = await filtersService.index();
    const smartFilters = filtersService.indexSmartFilter(this.sef_url as string);

    for (let filter of filters) {
      if (filter.type) {
        const filterLogic = this.createFilter(filter);
        if (filterLogic.initialize(this.excursions)) {
          const smartFilter = smartFilters.find(f => f.name === filter.code.toLocaleLowerCase());

          if (smartFilter) {
            if (filter.type === "number") {
              (filterLogic as NumberFilterLogic).setValues(+smartFilter.value[0], +smartFilter.value[1]);
            }
            if (filter.type === "select") {
              for (const option of smartFilter.value) {
                (filterLogic as SelectFilterLogic).checkOption(option as string);
              }
            }
          }

          this.filters.push(filterLogic);
        }
      }
    }
  }
})
